module.exports = __webpack_public_path__ + "static/media/sliced_tomatoes.57426d59.png";